import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { connectorTool } from './ConnectorTool';
import { ConnectorToolWidget } from './ConnectorToolWidget';

export const connectorToolboxItem = ToolboxItem({
    id: 'connectorTool',
    weight: 1046,
    ui: ConnectorToolWidget,
    shortcut: 'X',
    tools: [connectorTool]
});

